import { Box } from '@mui/material';
import {
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  Title,
  Tooltip,
} from 'chart.js';
import annotationPlugin from 'chartjs-plugin-annotation';
import React from 'react';
import { Bar } from 'react-chartjs-2';
import LoadingSpinner from '../commonUI/LoadingSpinner';
import { useBlueberryClassDistributionChart } from './hooks/useBlueberryClassDistributionChart';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  annotationPlugin
);

ChartJS.defaults.font.size = 16;
ChartJS.defaults.borderColor = '#7c7e80'; // darkTheme.grey.muted (set outside of theme context here)

interface Props {
  plugins?: object;
}

const BarChart: React.FC<Props> = ({ plugins }) => {
  const chartRef = React.useRef<ChartJS<'bar', number[], unknown> | null>(null);
  const { data, options, isLoading } = useBlueberryClassDistributionChart(
    chartRef.current,
    plugins
  );

  return (
    <>
      {isLoading && (
        <Box
          sx={{
            width: '100%',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <LoadingSpinner />
        </Box>
      )}
      {!isLoading && data && (
        <Bar
          ref={chartRef}
          data={data}
          options={options}
          style={{
            maxWidth: '100%',
            maxHeight: '100%',
            minWidth: '300px',
            position: 'absolute', // this is needed to make the chart responsive - https://github.com/chartjs/Chart.js/issues/9001
          }}
        />
      )}
    </>
  );
};

export default BarChart;
